

export class CompanyRuleDetailsAddInput implements ICompanyRuleDetailsAddInput {
    /** The auto-generated id of the company details master */
    companyDetailsId!: number;
    /** The date of rule valid from */
    validFrom!: string;
    /** The event date formate should be "MM-dd-yyyy" or  "dd-MM-yyyy" */
    eventDateFormate!: string;
    /** The event time formate should be "HH:mm:ss" or  "hh:mm:ss a" */
    eventTimeFormate!: string;
    /** The device accuracy tolerance in meter */
    deviceAccuracyTolerance!: number;
    /** The device distance variation should be "-" or  "+" */
    deviceDistanceVariation!: string;
    /** The device distance variation percentage */
    deviceDistanceVariationPercentage!: number;
    /** The POI tolerance */
    poiTolerance!: number;
    /** The max speed validator */
    maxSpeedValidator!: number;
    /** The speed consideration moment */
    speedConsiderationMoment!: number;
    /** The tour start buffer time should be in HH:mm:ss */
    tourStartBufferTime!: string;
    /** The sms alert from time should be in HH:mm:ss */
    smsAlertFrom!: string;
    /** The sms alert to time should be in HH:mm:ss */
    smsAlertTo!: string;
    /** The inactive time */
    inactiveTime!: number;
    /** The stoppage time */
    stoppageTime!: number;
    /** The idle time */
    idleTime!: number;
    /** The speed limit */
    speedLimit!: number;
    /** The ignition on first start should be 0 or 1 */
    ignitionOnFirstStart!: number;
    /** The show cluster should be 0 or 1 */
    showCluster!: number;
    /** The report start time */
    reportStartTime!: string;
    /** The report end time */
    reportEndTime!: string;
    /** The sms reserved quantity */
    smsReservedQuantity!: number;
    /** The welcome message with 500 character */
    welcomeMessage!: string;
    /** The authenticate should be 0 or 1 */
    authenticate!: number;
    /** The geofence alert should be 0 or 1 */
    geofenceAlert!: number;
    /** The vehicle info1 should be 0 or 1 */
    vehicleInfo1!: number;
    /** The vehicleInfo description 1 with 500 character */
    vehicleInfoDescription1!: string;
    /** The vehicle info2 should be 0 or 1 */
    vehicleInfo2!: number;
    /** The vehicleInfo description 2 with 500 character */
    vehicleInfoDescription2!: string;
    /** The vehicle info3 should be 0 or 1 */
    vehicleInfo3!: number;
    /** The vehicleInfo description 3 with 500 character */
    vehicleInfoDescription3!: string;
    /** The vehicle info4 should be 0 or 1 */
    vehicleInfo4!: number;
    /** The vehicleInfo description 4 with 500 character */
    vehicleInfoDescription4!: string;
    /** The vehicle info5 should be 0 or 1 */
    vehicleInfo5!: number;
    /** The vehicleInfo description 5 with 500 character */
    vehicleInfoDescription5!: string;

    constructor(data?: ICompanyRuleDetailsAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyDetailsId = _data["companyDetailsId"];
            this.validFrom = _data["validFrom"];
            this.eventDateFormate = _data["eventDateFormate"];
            this.eventTimeFormate = _data["eventTimeFormate"];
            this.deviceAccuracyTolerance = _data["deviceAccuracyTolerance"];
            this.deviceDistanceVariation = _data["deviceDistanceVariation"];
            this.deviceDistanceVariationPercentage = _data["deviceDistanceVariationPercentage"];
            this.poiTolerance = _data["poiTolerance"];
            this.maxSpeedValidator = _data["maxSpeedValidator"];
            this.speedConsiderationMoment = _data["speedConsiderationMoment"];
            this.tourStartBufferTime = _data["tourStartBufferTime"];
            this.smsAlertFrom = _data["smsAlertFrom"];
            this.smsAlertTo = _data["smsAlertTo"];
            this.inactiveTime = _data["inactiveTime"];
            this.stoppageTime = _data["stoppageTime"];
            this.idleTime = _data["idleTime"];
            this.speedLimit = _data["speedLimit"];
            this.ignitionOnFirstStart = _data["ignitionOnFirstStart"];
            this.showCluster = _data["showCluster"];
            this.reportStartTime = _data["reportStartTime"];
            this.reportEndTime = _data["reportEndTime"];
            this.smsReservedQuantity = _data["smsReservedQuantity"];
            this.welcomeMessage = _data["welcomeMessage"];
            this.authenticate = _data["authenticate"];
            this.geofenceAlert = _data["geofenceAlert"];
            this.vehicleInfo1 = _data["vehicleInfo1"];
            this.vehicleInfoDescription1 = _data["vehicleInfoDescription1"];
            this.vehicleInfo2 = _data["vehicleInfo2"];
            this.vehicleInfoDescription2 = _data["vehicleInfoDescription2"];
            this.vehicleInfo3 = _data["vehicleInfo3"];
            this.vehicleInfoDescription3 = _data["vehicleInfoDescription3"];
            this.vehicleInfo4 = _data["vehicleInfo4"];
            this.vehicleInfoDescription4 = _data["vehicleInfoDescription4"];
            this.vehicleInfo5 = _data["vehicleInfo5"];
            this.vehicleInfoDescription5 = _data["vehicleInfoDescription5"];
        }
    }

    static fromJS(data: any): CompanyRuleDetailsAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRuleDetailsAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyDetailsId"] = this.companyDetailsId;
        data["validFrom"] = this.validFrom;
        data["eventDateFormate"] = this.eventDateFormate;
        data["eventTimeFormate"] = this.eventTimeFormate;
        data["deviceAccuracyTolerance"] = this.deviceAccuracyTolerance;
        data["deviceDistanceVariation"] = this.deviceDistanceVariation;
        data["deviceDistanceVariationPercentage"] = this.deviceDistanceVariationPercentage;
        data["poiTolerance"] = this.poiTolerance;
        data["maxSpeedValidator"] = this.maxSpeedValidator;
        data["speedConsiderationMoment"] = this.speedConsiderationMoment;
        data["tourStartBufferTime"] = this.tourStartBufferTime;
        data["smsAlertFrom"] = this.smsAlertFrom;
        data["smsAlertTo"] = this.smsAlertTo;
        data["inactiveTime"] = this.inactiveTime;
        data["stoppageTime"] = this.stoppageTime;
        data["idleTime"] = this.idleTime;
        data["speedLimit"] = this.speedLimit;
        data["ignitionOnFirstStart"] = this.ignitionOnFirstStart;
        data["showCluster"] = this.showCluster;
        data["reportStartTime"] = this.reportStartTime;
        data["reportEndTime"] = this.reportEndTime;
        data["smsReservedQuantity"] = this.smsReservedQuantity;
        data["welcomeMessage"] = this.welcomeMessage;
        data["authenticate"] = this.authenticate;
        data["geofenceAlert"] = this.geofenceAlert;
        data["vehicleInfo1"] = this.vehicleInfo1;
        data["vehicleInfoDescription1"] = this.vehicleInfoDescription1;
        data["vehicleInfo2"] = this.vehicleInfo2;
        data["vehicleInfoDescription2"] = this.vehicleInfoDescription2;
        data["vehicleInfo3"] = this.vehicleInfo3;
        data["vehicleInfoDescription3"] = this.vehicleInfoDescription3;
        data["vehicleInfo4"] = this.vehicleInfo4;
        data["vehicleInfoDescription4"] = this.vehicleInfoDescription4;
        data["vehicleInfo5"] = this.vehicleInfo5;
        data["vehicleInfoDescription5"] = this.vehicleInfoDescription5;
        return data; 
    }
}

export interface ICompanyRuleDetailsAddInput {
    /** The auto-generated id of the company details master */
    companyDetailsId: number;
    /** The date of rule valid from */
    validFrom: string;
    /** The event date formate should be "MM-dd-yyyy" or  "dd-MM-yyyy" */
    eventDateFormate: string;
    /** The event time formate should be "HH:mm:ss" or  "hh:mm:ss a" */
    eventTimeFormate: string;
    /** The device accuracy tolerance in meter */
    deviceAccuracyTolerance: number;
    /** The device distance variation should be "-" or  "+" */
    deviceDistanceVariation: string;
    /** The device distance variation percentage */
    deviceDistanceVariationPercentage: number;
    /** The POI tolerance */
    poiTolerance: number;
    /** The max speed validator */
    maxSpeedValidator: number;
    /** The speed consideration moment */
    speedConsiderationMoment: number;
    /** The tour start buffer time should be in HH:mm:ss */
    tourStartBufferTime: string;
    /** The sms alert from time should be in HH:mm:ss */
    smsAlertFrom: string;
    /** The sms alert to time should be in HH:mm:ss */
    smsAlertTo: string;
    /** The inactive time */
    inactiveTime: number;
    /** The stoppage time */
    stoppageTime: number;
    /** The idle time */
    idleTime: number;
    /** The speed limit */
    speedLimit: number;
    /** The ignition on first start should be 0 or 1 */
    ignitionOnFirstStart: number;
    /** The show cluster should be 0 or 1 */
    showCluster: number;
    /** The report start time */
    reportStartTime: string;
    /** The report end time */
    reportEndTime: string;
    /** The sms reserved quantity */
    smsReservedQuantity: number;
    /** The welcome message with 500 character */
    welcomeMessage: string;
    /** The authenticate should be 0 or 1 */
    authenticate: number;
    /** The geofence alert should be 0 or 1 */
    geofenceAlert: number;
    /** The vehicle info1 should be 0 or 1 */
    vehicleInfo1: number;
    /** The vehicleInfo description 1 with 500 character */
    vehicleInfoDescription1: string;
    /** The vehicle info2 should be 0 or 1 */
    vehicleInfo2: number;
    /** The vehicleInfo description 2 with 500 character */
    vehicleInfoDescription2: string;
    /** The vehicle info3 should be 0 or 1 */
    vehicleInfo3: number;
    /** The vehicleInfo description 3 with 500 character */
    vehicleInfoDescription3: string;
    /** The vehicle info4 should be 0 or 1 */
    vehicleInfo4: number;
    /** The vehicleInfo description 4 with 500 character */
    vehicleInfoDescription4: string;
    /** The vehicle info5 should be 0 or 1 */
    vehicleInfo5: number;
    /** The vehicleInfo description 5 with 500 character */
    vehicleInfoDescription5: string;
}

